// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"a96b4eb1","256":"bcb30a5b","453":"64aababc","459":"353a57a7","494":"c46f2326","618":"ae613ce1","908":"2874fe8d","980":"93eac69c"}[chunkId] + ".chunk.js";
};